import DeviceFrame from "@/components/DeviceFrame";
import AppDownloadSection from "@/components/AppDownloadSection";

export const LandingAppDownload = () => {
  return (
    <div className="mt-16 md:mt-20 grid lg:grid-cols-2 gap-12 items-start">
      <div className="flex justify-center order-2 lg:order-1">
        <div className="w-full max-w-md flex justify-center">
          <DeviceFrame className="w-48 md:w-56">
            <img
              src="/lovable-uploads/fbe5bcd2-894e-4a42-8667-1ef1066a9a67.webp"
              alt="BRRGR home feed screenshot – recent burger check-ins"
              width={224}
              height={484}
              className="h-full w-full object-cover"
              loading="lazy"
              decoding="async"
            />
          </DeviceFrame>
        </div>
      </div>
      <div className="order-1 lg:order-2 flex justify-center">
        <div className="w-full max-w-md flex flex-col items-center lg:items-start text-center lg:text-left">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground">
            Get the <span className="italic text-primary">BRRGR</span> app
          </h2>
          <p className="mt-2 text-base text-foreground/70">
            Download the app now to track your burger legacy and discover the best burgers around you.
          </p>
          <div className="mt-6 w-full flex justify-center lg:justify-start">
            <AppDownloadSection hideHeading />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingAppDownload;
